/* global System */
// register component(s) with react habitat

export default { Openings: () => System.import('./index') }
